export default function Contact() {
  return (
    <section id="contact" className="bg-[#1A3A3A] text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="world-pattern" x="0" y="0" width="100" height="100" patternUnits="userSpaceOnUse">
              <circle cx="50" cy="50" r="1" fill="currentColor" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#world-pattern)" />
        </svg>
      </div>

      <div className="container mx-auto px-16 py-20 relative z-10">
        <div className="grid grid-cols-12 gap-16 mb-16">
          <div className="col-span-5">
            <div className="flex items-center gap-2 mb-6">
              <h4 className="text-2xl font-bold" style={{ fontFamily: 'Playfair Display, serif' }}>
                SEMBODJA OOD
              </h4>
              <span className="w-2 h-2 bg-[#6B8E6B] rounded-full"></span>
            </div>
            
            <p className="text-3xl font-light leading-relaxed mb-8" style={{ fontFamily: 'Playfair Display, serif' }}>
              Building the future of<br />mobile security
            </p>

            <p className="text-sm text-white/70 leading-relaxed">
              We are committed to delivering exceptional iOS applications that prioritize user privacy, security, and performance. Our team of experts works tirelessly to create innovative solutions for modern mobile users.
            </p>
          </div>

          <div className="col-span-7">
            <div className="grid grid-cols-2 gap-12">
              <div>
                <h5 className="text-base font-semibold mb-6 uppercase tracking-wider">Contact Information</h5>
                <ul className="space-y-4">
                  <li className="flex items-start gap-3">
                    <i className="ri-map-pin-line text-lg mt-1 w-5 h-5 flex items-center justify-center"></i>
                    <div>
                      <p className="text-sm font-medium">Address</p>
                      <p className="text-sm text-white/80">51 Osogovo str.</p>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-building-line text-lg mt-1 w-5 h-5 flex items-center justify-center"></i>
                    <div>
                      <p className="text-sm font-medium">City</p>
                      <p className="text-sm text-white/80">Sofia</p>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-mail-line text-lg mt-1 w-5 h-5 flex items-center justify-center"></i>
                    <div>
                      <p className="text-sm font-medium">Zip</p>
                      <p className="text-sm text-white/80">1303</p>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-global-line text-lg mt-1 w-5 h-5 flex items-center justify-center"></i>
                    <div>
                      <p className="text-sm font-medium">Country</p>
                      <p className="text-sm text-white/80">Bulgaria</p>
                    </div>
                  </li>
                </ul>
              </div>

              <div>
                <h5 className="text-base font-semibold mb-6 uppercase tracking-wider">Get In Touch</h5>
                <ul className="space-y-4">
                  <li className="flex items-start gap-3">
                    <i className="ri-mail-send-line text-lg mt-1 w-5 h-5 flex items-center justify-center"></i>
                    <div>
                      <p className="text-sm font-medium">Email</p>
                      <a href="mailto:info@sembodjaood.com" className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                        info@sembodjaood.com
                      </a>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-phone-line text-lg mt-1 w-5 h-5 flex items-center justify-center"></i>
                    <div>
                      <p className="text-sm font-medium">Number</p>
                      <a href="tel:+14345973713" className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                        +1 4345973713
                      </a>
                    </div>
                  </li>
                </ul>

                <div className="mt-8">
                  <h5 className="text-base font-semibold mb-4 uppercase tracking-wider">Follow Us</h5>
                  <div className="flex gap-4">
                    <button className="w-10 h-10 flex items-center justify-center border-2 border-white/30 rounded-lg hover:border-white hover:bg-white/10 transition-all cursor-pointer">
                      <i className="ri-facebook-fill text-lg"></i>
                    </button>
                    <button className="w-10 h-10 flex items-center justify-center border-2 border-white/30 rounded-lg hover:border-white hover:bg-white/10 transition-all cursor-pointer">
                      <i className="ri-twitter-x-fill text-lg"></i>
                    </button>
                    <button className="w-10 h-10 flex items-center justify-center border-2 border-white/30 rounded-lg hover:border-white hover:bg-white/10 transition-all cursor-pointer">
                      <i className="ri-linkedin-fill text-lg"></i>
                    </button>
                    <button className="w-10 h-10 flex items-center justify-center border-2 border-white/30 rounded-lg hover:border-white hover:bg-white/10 transition-all cursor-pointer">
                      <i className="ri-instagram-fill text-lg"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8">
          <div className="flex items-center justify-between">
            <p className="text-sm text-white/60">
              © 2025 SEMBODJA OOD. All rights reserved.
            </p>
            <div className="flex items-center gap-8">
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
